﻿/**
* DevExpress HTML/JS Reporting (dx-reporting-version.js)
* Version:  22.2.15
* Build date: Feb 11, 2025
* Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export const version = '22.2.15';
